<template>
  <v-container>
    <v-col cols="12">
      <h1>Recursos de glosa
        <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          color="primary" 
                          icon
                          small
                          @click=listaModal()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Ajuda</span>
                        </v-tooltip>
                  </span>
      </h1>
    </v-col>
    <v-tabs v-model="tab" class="elevation-0 px-3">
      <v-tab >Por pagamento</v-tab>
      <v-tab >Por competência</v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <RecursosDeGlosaGeral />
        </v-tab-item>
        <v-tab-item>
          <RecursosDeGlosaPorCompetencia />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>

<script>
import RecursosDeGlosaGeral from './recursos_de_glosa/RecursosDeGlosaGeral.vue'
import RecursosDeGlosaPorCompetencia from './recursos_de_glosa/RecursosDeGlosaPorCompetencia.vue'

export default {
  components: {
    RecursosDeGlosaGeral,
    RecursosDeGlosaPorCompetencia
  },
  data() {
    return {
      tab: null
    }
  },

  methods: {
    listaModal(){
      let paramModal = {
        type: "tutorial",
        title:"Ajuda",
        message: "Clique no título da ajuda para ver o vídeo explicativo.",
        callback: null,
        btConfirm: { name: "Fechar", show: true },
        listaLink: {
          show: true,
          lista: [
            {  title: "Como realizar o recurso de glosa", 
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754810261", title:"Como realizar o recurso de glosa" })}
            },
            {  title: "Como preencher o formulário do recurso de glosa",
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754810295", title:"Como preencher o formulário do recurso de glosa"})}
            },
            {  title: "Como realizar o upload do recurso de glosa", 
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754810332", title:"Como realizar o upload do recurso de glosa" })}
            },
            {  title: "Como preencher protocolo para recurso manual",
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754810365", title:"Como preencher protocolo para recurso manual"})}
            },
            {  title: "Como concluir o envio do recurso",
            callback:()=>{this.$store.commit('tutorial/abreVideo', {codigo:"754810402", title:"Como concluir o envio do recurso"})}
            },
          ]
        }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
    },
  }
};
</script>
